import React, { Component } from 'react';
import {Fieldset} from 'primereact/fieldset';
import UserManual from '../../assets/pdf/HRApprova_User_Manual.pdf';
import LeavePolicy from '../../assets/pdf/Policy_Leaves.pdf';

export class Policy extends Component {
    state = {
        userID: 'u123456',
        
    }

 
    render() {
        let name = this.props.match.params.name || '';
        let source;
        if(name == 'Leave Policy'){
            source = LeavePolicy;
        } else source = UserManual;
       

        return (
            

            <div className="p-col-12">
                <div className="card card-w-title">
                    <h1>{name}</h1>
                    <Fieldset legend={name} className="mt1" toggleable={true}>
                    <embed type="application/pdf" src={source} width="100%" style={{height : '100vh'}} alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" background-color="0xFF525659" top-toolbar-height="56" full-frame="" internalinstanceid="21" title="CHROME"/>
                    </Fieldset>
                </div>
            </div>
        );
    }
}